// extracted by mini-css-extract-plugin
export default {"page":"E0-z","cartModal":"F0-z","checkout":"G0-z","placeholder":"H0-z","account":"I0-z"};